<div class="search-fields">
  <div class="form-section" id="searchFieldPharmacy">
    <input class="btn search-icon" type="submit" value="" name="submit" />
    <input class="form-control" type="text" placeholder="Type your drug name ( e.g pantoprazole, Amlodipine etc. )"
      (keyup)="TypeDrug($event);ShowHistory();$event.stopPropagation();"
      (click)="ShowHistory();$event.stopPropagation();" (focus)="setHeight('focusin');"
      (blur)="clearHeight();getCardShow()" value="{{ SelectedDrug }}" [(ngModel)]="SelectedDrug" id="SearchDrugText"
      autocomplete="off" (focus)="getCardHide()" />
    <div *ngIf="errorShowDisplay">
      <span *ngIf="errorShowDisplay" class="errorSearchMsg"><span>{{ searchtextbox_error }}</span></span>
    </div>
    <div class="serachlist" *ngIf="ShowDisplay">
      <div class="recent_sesrch" *ngIf="ShowRecentSearch" id="CheckLoginState">
        <div class="title" style="color:#f19f57" *ngIf="NoDrugsFound">No items found with this search</div>
        <div class="title heading" id="RS">Recent Searches</div>
        <ul>
          <li *ngFor="let item of SearchItemArray" (focusout)="setHeight('focusout')" (click)="DrugSetting(item.text);">
            {{ item.text }}
          </li>
        </ul>
      </div>
    </div>

    <!---List based on user typed drug-->
    <div class="serachlist" *ngIf="DisplayBindList">
      <ul>
        <li *ngFor="let item of SearchList" (click)="DrugSetting(item.DrugName)">
          {{ item.DrugName }}
        </li>
      </ul>
    </div>
    <!-- <div class="search_btn btn lowest btn-hover-effect" (click)="ClickDrug()">
      <div class='insider'></div>Find the Lowest Price
    </div> -->
  </div>
</div>

<!--Search pharmacy popup-->
<div class="search_pharmacy_popup" *ngIf="ShowDrugdetails">
  <div class="close_search_pharmacy_popup is-hidden-mobile  " (click)="CloseDrugDetails()"></div>
  <div class="search_pharmacy_select">
    <div class="close_search_pharmacy_popup is-hidden-desktop" (click)="CloseDrugDetails()"></div>
    <!-- <h2>Atenolol ( Generic Tenormin )</h2> -->
    <h2>{{ SelectedDrug }}</h2>
    <div class="filter_box">
      <div class="lists_box" [ngClass]="{'singleDoseForm': DrugNameTypeSingle}">
        <div (click)="hideme[0] = !hideme[0]; $event.stopPropagation()">
          <label>Type</label>
          <div class="filtertext">
            {{ SelectedDrug }}
          </div>
          <i></i>
        </div>
        <div class="lists" [hidden]="!hideme[0]">
          <ul>
            <li *ngFor="let item of DrugTypeList" (click)="addActive_select($event, 0, item)"
              [ngClass]="{ active: item == Swap_Drug_With_MultiSource }">
              {{ item }}
            </li>
            <!-- <li>None</li>
                  <li>Atenolol</li>
                  <li>Atenolol</li>
                  <li>Atenolol</li> -->
          </ul>
        </div>
      </div>
      <div class="lists_box" [ngClass]="{'singleDoseForm': DrugFormSingle}">
        <div (click)="hideme[1] = !hideme[1]; $event.stopPropagation()">
          <label>Form</label>
          <div class="filtertext">
            {{ DrugType }}
          </div>
          <i></i>
        </div>
        <div class="lists" [hidden]="!hideme[1]">
          <ul>
            <li *ngFor="let item of optionlist" (click)="addActive_select($event, 1, item.text)"
              [ngClass]="{ active: item.text == DrugType }">
              {{ item.text }}
            </li>
          </ul>
        </div>
      </div>
      <div class="lists_box" [ngClass]="{'singleDoseForm': DrugDoseSingle}">
        <div (click)="hideme[2] = !hideme[2]; $event.stopPropagation()">
          <label>Dosage</label>
          <div class="filtertext">
            {{ DrugDose }}
          </div>
          <i></i>
        </div>
        <div class="lists" [hidden]="!hideme[2]">
          <ul>
            <li *ngFor="let item of DrugDoseList" (click)="addActive_select($event, 2, item)"
              [ngClass]="{ active: item == DrugDose }">
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
      <div class="lists_box">
        <div (click)="hideme[3] = !hideme[3]; $event.stopPropagation()">
          <label>Quantity</label>
          <div class="filtertext">
            {{ DrugQuant }}
          </div>
          <i></i>
        </div>
        <div class="lists" [hidden]="!hideme[3]">
          <ul>
            <li *ngFor="let item of DrugQuantityList" (click)="addActive_select($event, 3, item, item.NDCCode)"
              [ngClass]="{ active: item.DisplayQuantity === DrugQuant }">{{ item.DisplayQuantity }}</li>
            <!-- <li (click)="addActive_select($event, -3, QuantityManual)">Enter a Quantity</li> -->
          </ul>
        </div>
      </div>
      <div class="lists_box PharmacyNear">
        <div>
          <label>Pharmacies Near</label>

          <!-- <div class="filtertext">Oakland, CA 94618, USA</div> -->
          <div class="filtertext">
            <input id="getzipcode" type="tel" placeholder="Type zipcode" value="{{ _CurrLocation }}"
              [(ngModel)]="_UserZip" (click)="ClearErrorMessage()" (keypress)="ZipCodeValidate($event)"
              autocomplete="off" (keyup)="zipCodeLenthInit();" maxlength="5" class="padding-left-0" />
          </div>
          <!-- <i></i> -->
          <span>{{ ZipCodeMessage }}</span>
        </div>
      </div>
      <div class="autopic_location">
        <input type="checkbox" id="pick_location" (change)="GetAutoLocation($event)" />
        <label for="pick_location"><span class="check_box"></span>Auto pick my location</label>
      </div>
      <div class="find_button" (click)="Redirect_LoadPharmacy()">
        Find the Lowest Price
      </div>
    </div>
  </div>
</div>

<app-loader-popup *ngIf="loader"></app-loader-popup>

<app-error-popup
  *ngIf="errorPopup"
  [errorMsg]="'No details available for this drug.'"
  (hidePopup)="errorPopupToggle($event)"></app-error-popup>

<!-- Enter Quantity Manual Box -->
<!-- <div class="change_password ManualQuantity_box" *ngIf="ManualQuantity_box">
  <div class="close_search_pharmacy_popup is-hidden-mobile" (click)="CloseQuantity_Box()"></div>
  <div class="changepassword_main forgot_pass">
    <div class="close_search_pharmacy_popup is-hidden-desktop" (click)="CloseQuantity_Box()"></div>
    <h2>Enter a quantity</h2>
    <div class="input_box">
      <div class="clearfix">
        <input type="number" id="Quantity_Manual" name="Quantity_Manual" placeholder=" " [(ngModel)]="Quantity_Manual"
          (keypress)="DrugQuantityValidate($event)" />
        <label for="Quantity_Manual">Quantity</label>
      </div>
      <span id="Quant_Error">{{ Quantity_error }}</span>
      <div class="reset_button" (click)="SubmitQuantity()">Submit</div>
    </div>
  </div>
</div> -->